export function isTimesheetHR(user, hasApiPermission) {
    return !!user?.is_superuser || hasApiPermission('rbacapp.hr_act');
}

export function isLeaveHR(user) {
    return !!user?.is_superuser || !!user?.permissions?.includes('rbacapp.hr_act');
}
